import React from 'react';
import { UserPlus, ChevronRight, Calendar } from 'lucide-react';

const TeamGameManagement = ({ onNavigate, permissions }) => {
    if (!permissions.canManageTeams) return null;

    return (
        <div>
            <h3 className="text-lg font-bold text-gray-900 mb-3">🏏 Team & Game Management</h3>
            <div className="grid grid-cols-2 gap-4">
                <button
                    onClick={() => onNavigate('manage-players')}
                    className="group flex items-center gap-4 bg-gradient-to-r from-indigo-50 to-purple-50 hover:from-indigo-100 hover:to-purple-100 rounded-xl p-4 transition-all text-left border border-indigo-100"
                >
                    <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                        <UserPlus className="text-indigo-600" size={20} />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="font-bold text-gray-900 truncate">Manage Players</h3>
                        <p className="text-xs text-gray-500 truncate">Add or remove members</p>
                    </div>
                    <ChevronRight className="text-indigo-300 group-hover:text-indigo-600 transition-colors shrink-0" size={18} />
                </button>

                <button
                    onClick={() => onNavigate('games-list')}
                    className="group flex items-center gap-4 bg-gradient-to-r from-purple-50 to-pink-50 hover:from-purple-100 hover:to-pink-100 rounded-xl p-4 transition-all text-left border border-purple-100"
                >
                    <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                        <Calendar className="text-purple-600" size={20} />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="font-bold text-gray-900 truncate">View Games</h3>
                        <p className="text-xs text-gray-500 truncate">See scheduled games</p>
                    </div>
                    <ChevronRight className="text-purple-300 group-hover:text-purple-600 transition-colors shrink-0" size={18} />
                </button>
            </div>
        </div>
    );
};

export default TeamGameManagement;
